'use client'

import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

import { useAccessibility } from '../AccessibilityProvider'

export function MotionSection() {
  const { settings, update, announce } = useAccessibility()

  return (
    <section aria-labelledby="a11y-motion-heading" className="flex flex-col gap-4">
      <h3 id="a11y-motion-heading" className="text-base font-semibold">
        Pokret
      </h3>

      <div className="flex flex-col gap-3">
        <div className="flex items-start justify-between gap-3">
          <Label htmlFor="reduced-motion" className="flex flex-1 cursor-pointer flex-col gap-0.5">
            <span>Smanji animacije</span>
            <span className="text-muted-foreground text-xs font-normal">
              Pauzira tranzicije i auto-pokrete
            </span>
          </Label>
          <Switch
            id="reduced-motion"
            checked={settings.reducedMotion}
            onCheckedChange={(checked) => {
              update({ reducedMotion: checked })
              announce(`Animacije: ${checked ? 'smanjene' : 'uključene'}`)
            }}
          />
        </div>

        <div className="flex items-start justify-between gap-3">
          <Label htmlFor="autoplay-video" className="flex flex-1 cursor-pointer flex-col gap-0.5">
            <span>Auto-play video</span>
            <span className="text-muted-foreground text-xs font-normal">
              Automatsko pokretanje video zapisa pri otvaranju lekcije
            </span>
          </Label>
          <Switch
            id="autoplay-video"
            checked={settings.autoplayVideo}
            onCheckedChange={(checked) => {
              update({ autoplayVideo: checked })
              announce(`Auto-play video: ${checked ? 'uključen' : 'isključen'}`)
            }}
          />
        </div>
      </div>
    </section>
  )
}
